import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { Store } from 'redux';
import { DialogState } from '../models/DialogState';

export const SHOW_MORE = 'SHOW_MORE';

export class ShowMoreAction implements IDialogAction {
    public readonly type = SHOW_MORE;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            let state = store.getState() as DialogState;
            this._service.showMore(state.feed.currentTabId, state.feed.lastActivityId, state.feed.pageNumber);
        }
        return;
    }
    public reducer(state: DialogState): any {
        state.feed.messagesReady = false;
        return state;
    }
}


export const ShowMoreActionTypeMapping = {
    [SHOW_MORE]: ShowMoreAction
}